import { PublicClientApplication } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/logo-header.png";
function HeaderAdmin({ verifiedToken }: any) {
  const navigate = useNavigate();
  const { instance } = useMsal();
  async function onLogoutClick() {
    try {
      await instance.logoutPopup({
        account: instance.getAccountByHomeId(
          JSON.parse(localStorage.getItem("homeAccountId") as string)
        ),
        mainWindowRedirectUri: "/signin",
      });
      localStorage.removeItem("infoSignin");
    } catch (err) {
      console.log("errr");
    }
  }
  return (
    <>
      <div className="xsm:h-20 xs:h-24 flex items-center w-[100%] relative">
        <div className="flex justify-center w-[100%] ">
          <img src={logo} alt="logo" />
        </div>
        {verifiedToken && (
          <div
            className=" right-6 absolute top-0 cursor-pointer "
            onClick={onLogoutClick}
          >
            <div className="bg-[#eed484] xsm:h-16 xs:h-20 xsm:w-[65px] xs:w-[75px] rounded-b-lg flex justify-center items-center hover:bg-[#dac176]">
              <div className=" flex flex-col gap-2 ">
                <div className="flex justify-center">
                  <Icon icon={"mdi:logout"} width={20} />
                </div>
                <div className="flex justify-center xsm:text-[12px] xs:text-[14px]">
                  Sign out
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default HeaderAdmin;
